'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var MarketProductAnalysisGridController = function MarketProductAnalysisGridController($scope, $rootScope, reoptimizationService, scenarioService, momentService, calculateEffectiveValueService, dataRetrieverService, overridesUtilsService, directForecastingConfigurationService, featureToggleService, pooledReviewCalendarService, pooledSeasonalityChartDataTransformationService, selectedMarketHelperService, userPreferencesService) {
  $scope.cogOptions = require('../config/cogOptions');
  $scope.marketProductGroupContextMenuItems = [];
  if (_.isUndefined($scope.flowType)) {
    $scope.flowType = featureToggleService.isEnabled('MAPPED_MODE') ? 'regular' : 'mapped';
  }
  function setupContextMenu() {
    $scope.marketProductGroupContextMenuItems = [];
    var market = selectedMarketHelperService.getSelectedMarket(_.get($scope, 'filterData.markets'), _.get($scope, 'demandManagementData.main'));
    if (!directForecastingConfigurationService.isDirectForecastEnabled(market)) {
      $scope.marketProductGroupContextMenuItems.push({
        caption: 'Demand Transparency',
        event: 'context-menu:market-product-group-demand-transparency'
      });
    }
  }
  $scope.screenState = {
    isMarketProductGridExpanded: userPreferencesService.getUserSettingComponent('isMarketProductGridExpanded') || false
  };
  $scope.$on('gridExpand:market-product-group-analysis', function () {
    $scope.screenState.isMarketProductGridExpanded = !$scope.screenState.isMarketProductGridExpanded;
  });
  $scope.$on('reoptimizeMarketProductGrid', function (event, selectedRows) {
    reoptimizationService.reoptimizeFromMarketScreen(selectedRows, scenarioService.getSelectedScenarioName());
  });
  $scope.$on('context-menu:market-product-group-demand-transparency', function (event, selectedRows) {
    var selectedRow = selectedRows[0];
    if (!selectedRow) {
      return;
    }
    if (featureToggleService.isEnabled('POOLED_SEASONALITY')) {
      $scope.prepareDataForPooledSeasonality(selectedRow);
      return;
    }
    $rootScope.$broadcast('demand-transparency:swap', true, buildContextData(selectedRow));
  });
  $scope.prepareDataForPooledSeasonality = function (selectedRow) {
    var market = selectedRow.market.split('-');
    var filter = {
      origin: market[0],
      destination: market[1],
      active: true
    };
    pooledReviewCalendarService.getMarketCalendar(filter).then(function (calendars) {
      if (calendars && calendars.length > 0) {
        pooledReviewCalendarService.getMarketRTP(market[0], market[1]).then(function (marketRtps) {
          var contextData = buildContextData(selectedRow);
          var flowType = $scope.$parent.screenState ? $scope.flowType : 'Regular';
          $rootScope.$broadcast('demand-transparency:swap', true, {
            displayedCalendar: pooledSeasonalityChartDataTransformationService.convertToDisplayedCalendar(calendars[0], contextData),
            demandTransparencyAttributes: pooledSeasonalityChartDataTransformationService.createDemandTransparencyAttributes(contextData, marketRtps, flowType),
            demandData: contextData
          });
        })["catch"](function (e) {
          toastr.error('Error occured while retrieving Profile information');
        });
      } else {
        toastr.error('No Profiles found for Market ' + market[0] + '-' + market[1]);
      }
    })["catch"](function (e) {
      toastr.error('Error occured while retrieving Profile information');
    });
  };
  function buildContextData(selectedRow) {
    return {
      timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
      searchCriteria: {
        carrier: selectedRow.carrier,
        market: selectedRow.market,
        classGroup: selectedRow.classGroup,
        spos: selectedRow.posName,
        season: selectedRow.season,
        dowGroup: selectedRow.dowGroup,
        mappedProfileLevel: selectedRow.mappedProfileLevel,
        regularProfileLevel: selectedRow.regularProfileLevel,
        lastProcessedDateMoment: selectedRow.lastProcessedDateMoment,
        departureDate: selectedRow.departureDateMoment,
        daysToDeparture: selectedRow.daysToDeparture
      }
    };
  }
  $scope.onCellEditHandler = function (gridData, rowId, colName) {
    var rowData = gridData[rowId];
    var gridId = $scope.mode + '-analysis';
    var effectiveVal = calculateEffectiveValueService.getField(rowData, colName, gridId);
    if (effectiveVal) {
      rowData[effectiveVal.fieldName] = effectiveVal.value;
      return {
        ids: [rowId],
        fieldNames: [effectiveVal.fieldName]
      };
    }
  };
  $scope.customSaveValidation = function (overrides) {
    if (overridesUtilsService.validateStartRtpOverrides(overrides)) {
      return true;
    } else {
      toastr.error('Demand adjustment cannot be empty if startRtp is set');
      return false;
    }
  };
  dataRetrieverService.getDataRetriever($scope.screen, $scope.mode).isQueryingMoreDomains(!$scope.isDemandManagement);
  $scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
    if (mode === 'market-product-group') {
      setupContextMenu();
    }
  });
  setupContextMenu();
};
MarketProductAnalysisGridController.$inject = ['$scope', '$rootScope', 'ReoptimizationService', 'ScenarioService', 'MomentService', 'CalculateEffectiveValueService', 'DataRetrieverService', 'OverridesUtilsService', 'DirectForecastingConfigurationService', 'FeatureToggleService', 'PooledReviewCalendarService', 'PooledSeasonalityChartDataTransformationService', 'SelectedMarketHelperService', 'UserPreferencesService'];
module.exports = MarketProductAnalysisGridController;